import React, { useState, useCallback, ReactNode, createContext, useContext } from 'react';

import { OnboardingStep } from '../components/Onboarding/types';

type OnboardingStepsContextProps = {
  currentOnboardingStep: OnboardingStep | null;
  updateCurrentOnboardingStep: (newStep: OnboardingStep | null) => void;
  resetOnboarding: () => void;
};

export const OnboardingStepsContext = createContext<OnboardingStepsContextProps>({
  currentOnboardingStep: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  updateCurrentOnboardingStep: () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  resetOnboarding: () => {},
});

type OnboardingStepsProviderProps = {
  children: ReactNode;
};

// Helper function to validate the onboarding step
const validateOnboardingStep = (step: string | null): OnboardingStep | null => {
  const steps: OnboardingStep[] = [
    'ONBOARDING_STEP_1_ALL_ITEMS',
    'ONBOARDING_STEP_2_CATEGORIES',
    'ONBOARDING_STEP_3_ALL_OPTIONS',
    'ONBOARDING_STEP_4_CREATE',
    'ONBOARDING_COMPLETED',
    'ONBOARDING_SKIPPED',
  ];
  return steps.includes(step as OnboardingStep) ? (step as OnboardingStep) : null;
};

export const OnboardingStepsProvider: React.FC<OnboardingStepsProviderProps> = ({ children }) => {
  // TODO: the initial value of currentOnboardingStep comes from backend, add that when backend ready

  // Get the initial value from localStorage and validate it
  const initialStep = validateOnboardingStep(localStorage.getItem('currentOnboardingStep'));

  const [currentOnboardingStep, setcurrentOnboardingStep] = useState<OnboardingStep | null>(initialStep);

  // TODO: add the backend call to update the currentOnboardingStep when backend ready and remove localstorage
  const updateCurrentOnboardingStep = useCallback((newStep: OnboardingStep) => {
    setcurrentOnboardingStep(newStep);
    localStorage.setItem('currentOnboardingStep', newStep);
  }, []);

  const resetOnboarding = useCallback(() => {
    setcurrentOnboardingStep(null);
    localStorage.removeItem('currentOnboardingStep');
  }, []);

  return (
    <OnboardingStepsContext.Provider value={{ currentOnboardingStep, updateCurrentOnboardingStep, resetOnboarding }}>
      {children}
    </OnboardingStepsContext.Provider>
  );
};

export const useOnboardingStepsContext = () => useContext(OnboardingStepsContext);
